<template>
  <div class="simcardmanagement-container">
    <div class="simcard-layout" v-if="!isShowDetails">
      <div class="search-layout">
        <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('finance.name39')" prop="tenantId" v-if="userinfo.tenantType === 1 || userinfo.tenantType === 0">
            <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
          <!-- <el-form-item :label="$t('finance.name1')" prop="tenantId" v-if="userinfo.tenantType === 1">
            <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('bike.name65')" prop="ebikeId">
            <el-input class="input-layout" v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('finance.name26')" prop="imsi">
            <el-input class="input-layout" v-model="queryInfo.imsi" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('finance.name27')" prop="iccid">
            <el-input class="input-layout" v-model="queryInfo.iccid" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
      </el-form>
      </div>
      <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
        <el-table-column :label="$t('finance.name28')" prop="ebikeId" sortable></el-table-column>
        <el-table-column :label="$t('finance.name40')" prop="tenantId" sortable v-if="userinfo.tenantType === 0">
          <template slot-scope="scope">
            <div v-if="scope.row.parentName">{{ scope.row.parentName }}>{{ scope.row.tenantName }} </div>
            <div v-else>{{ scope.row.tenantName }} </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('bike.name105')" prop="tenantId" sortable v-if="userinfo.tenantType === 1">
          <template slot-scope="scope">
            <div>{{ scope.row.tenantName }} </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('finance.name29')" prop="imsi" sortable></el-table-column>
        <el-table-column :label="$t('finance.name30')" prop="iccid" sortable></el-table-column>
        <el-table-column :label="$t('finance.name31')" prop="updateTime" sortable>
          <template slot-scope="scope">
            {{ scope.row.updateTime | tzDisplay }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('finance.name15')" width="188px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetails(scope.row)">{{ $t('finance.name32') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <div class="details-layout" v-if="isShowDetails">
      <div class="close-layout"><i class="el-icon-close" @click="isShowDetails = false"></i></div>
      <div class="clbh-llxx">
        <div>{{ $t('finance.name33') }}{{ rowData.ebikeid }}</div>
        <div>{{ $t('finance.name34') }}{{ $t('finance.name35') }}{{ rowData.dataLimit }}M{{ $t('finance.name36') }}</div>
      </div>
      <div class="echarts-div" id="pieChart" ref="pieChart"></div>
    </div>
  </div>
</template>
<script>
import { findEbikeFlowPage, getResidueFlow } from '@/api/finance.js'
import { tenantList } from '@/api/manage.js'
import { sizeTostr } from '@/utils/utils'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      tenantIds: [],
      queryInfo: {
        ebikeId: '',
        pageNumber: 1,
        pageSize: 10,
        imsi: '',
        iccid: ''
      },
      tenantOptions: [],
      tableLoading: false,
      tableList: [],
      total: 0,
      pieChart: null,
      isShowDetails: false,
      rowData: {
        dataLimit: 0,
        currentCycleUsage: 0,
        residueFlow: 0
      }
    }
  },
  created() {
    window.addEventListener('resize', this.chartResize)
    if (this.userinfo.tenantType === 1) {
      this.getTenantList()
    }
    this.queryList()
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  },
  methods: {
    chartResize() {
      if (this.pieChart) {
        setTimeout(() => {
          this.pieChart.resize()
          this.setChartData()
        }, 10)
      }
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then((res) => {
          if (res.code === 200) {
            this.tenantOptions = res.data.list
          }
        })
        .catch(() => {})
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    setChartData() {
      const that = this
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          bottom: 'bottom',
          icon: 'rect',
          itemGap: 76,
          textStyle: {
            color: 'auto',
            fontSize: 14,
            rich: {
              m1: {
                color: '#FF8500'
              },
              m2: {
                color: '#0F73E6'
              }
            }
          },
          formatter: function(name) {
            if (name === that.$t('finance.name37')) {
              return `{m1| ${name}}`
            } else {
              return `{m2| ${name}}`
            }
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            color: ['#FF8500', '#0F73E6'],
            label: {
              alignTo: 'edge',
              formatter: '{m|{b} {c}M}',
              minMargin: 5,
              edgeDistance: 2,
              rich: {
                m: {
                  fontSize: 14
                }
              }
            },
            data: [
              {
                value: sizeTostr(that.rowData.currentCycleUsage),
                name: that.$t('finance.name37'),
                label: {
                  color: '#FF8500'
                }
              },
              {
                value: sizeTostr(that.rowData.residueFlow),
                name: that.$t('finance.name38'),
                label: {
                  color: '#0F73E6'
                }
              }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }

      this.pieChart.setOption(option)
    },
    resetQuery() {
      this.queryInfo = {
        ebikeId: '',
        pageNumber: 1,
        pageSize: 10,
        imsi: '',
        iccid: ''
      }
      this.tenantIds = []
      this.queryList()
    },
    getPageList() {
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      this.queryInfo.ebikeId = (this.queryInfo.ebikeId || '').trim()
      this.queryInfo.iccid = (this.queryInfo.iccid || '').trim()
      this.queryInfo.imsi = (this.queryInfo.imsi || '').trim()
      findEbikeFlowPage(this.queryInfo)
        .then((res) => {
          this.tableList = res.data.ebikeFlowPage.records
          this.total = res.data.ebikeFlowPage.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
          this.tableList = []
          this.total = 0
        })
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },
    goDetails(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name44'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        ebikeId: row.ebikeId,
        iccid: row.iccid
      }
      getResidueFlow(data).then((res) => {
        if (res.code === 200) {
          this.isShowDetails = true
          this.rowData = {
            dataLimit: sizeTostr(res.data.data.dataLimit),
            currentCycleUsage: res.data.data.currentCycleUsage,
            residueFlow: res.data.data.residueFlow,
            ebikeid: res.data.data.ebikeid
          }
          this.$nextTick(() => {
            this.pieChart = this.$echarts.init(this.$refs.pieChart, null, { renderer: 'svg' })
            this.setChartData()
          })
        }
        loading.close()
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.simcardmanagement-container {
  display: flex;
  flex-direction: column;
  .simcard-layout {
    display: flex;
    flex-direction: column;
  }
  .search-layout {
    display: flex;
    justify-content: space-between;
    .bt-layout {
      display: flex;
      flex-direction: row;
      height: 36px;
    }
    .search-layout-content {
      display: flex;
      flex-direction: row;

      .search-layout-item1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        > :first-child {
          font-size: 14px;
          // width: 74px;
        }
      }

      .search-layout-item2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 13px;
        > :first-child {
          font-size: 14px;
          // width: 74px;
        }
      }
      .search-layout-item3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-left: 13px;
        > :first-child {
          font-size: 14px;
          // width: 48px;
        }
      }
      .search-layout-item4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-left: 13px;
        > :first-child {
          font-size: 14px;
          // width: 90px;
        }
      }
    }

    .input-layout {
      width: 180px;
    }
  }
  .details-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    .close-layout {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      padding-right: 15px;
      .el-icon-close {
        cursor: pointer;
        font-size: 18px;
      }
    }
    .clbh-llxx {
      font-size: 14px;
      color: #000;
      font-weight: bold;
      display: flex;
      flex-direction: row;
      div {
        padding: 0 5px;
      }
    }
    .echarts-div {
      width: 700px;
      height: 700px;
    }
  }
}
</style>
